module.exports = __webpack_public_path__ + "pic/9.71a6aea4.png";